// extracted by mini-css-extract-plugin
export default {"disableClick":"J8Qsd"};